import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faRoute,
  faMapMarkerAlt,
  faHotel
} from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const DashboardContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.2rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  color: #316C6E;
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
`;

const StatsGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
  justify-content: space-between;
`;

const StatCard = styled.div`
  background: white;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 1.2rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  flex: 1;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const StatIcon = styled.div`
  color: #316C6E;
  font-size: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.2rem;
`;

const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
`;

const StatNumber = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  color: #316C6E;
`;

const StatLabel = styled.div`
  color: #666;
  font-size: 0.8rem;
  text-align: center;
`;

const ProfileDashboard = ({ stats, labels = null }) => {
  const { language } = useLanguage();
  const t = translations[language].pages.profile.stats;

  return (
    <DashboardContainer>
      <Title>{labels ? 'Operator Statistics' : t.title}</Title>
      <StatsGrid>
        <StatCard>
          <StatIcon>
            <FontAwesomeIcon icon={faRoute} />
          </StatIcon>
          <StatContent>
            <StatNumber>{stats.totalTrips}</StatNumber>
            <StatLabel>{labels ? labels.totalTrips : t.totalTrips}</StatLabel>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </StatIcon>
          <StatContent>
            <StatNumber>{stats.placesVisited}</StatNumber>
            <StatLabel>{labels ? labels.placesVisited : t.placesVisited}</StatLabel>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon>
            <FontAwesomeIcon icon={faHotel} />
          </StatIcon>
          <StatContent>
            <StatNumber>{stats.hotelsBooked}</StatNumber>
            <StatLabel>{labels ? labels.hotelsBooked : t.hotelsBooked}</StatLabel>
          </StatContent>
        </StatCard>
      </StatsGrid>
    </DashboardContainer>
  );
};

export default ProfileDashboard; 